// extracted by mini-css-extract-plugin
export var infoRow = "_ty-2";
export var labelContainer = "_ty-0";
export var rightInfo = "_ty-1";